export default {
    locale : document.head.querySelector('meta[name="locale"]').content,
    googlemap_api_token : document.head.querySelector('meta[name="gmap-api-key"]')
}
